<mat-form-field [class]="'full-width'">
    <textarea matInput placeholder="{{ label }}" [(ngModel)]="inputValue" ></textarea>
</mat-form-field>



